import { useHistory, useLocation } from 'react-router-dom'
import { utils } from 'passiv-libs'

const AuthWrapper = ({ children }) => {
  const history = useHistory()
  const location = useLocation()
  const isScreen = val => val === location.pathname.split('/')[1]

  if (!utils.auth.isLoggedIn() && !isScreen('login') && location.pathname !== '/email/update') {
    if (!isScreen('forgot') && !isScreen('reset')) history.push('/login')
  }

  if (
    !utils.settings.getAutoLogin() &&
    utils.cordova.isCordova() &&
    window.config.__REDIRECTTOLOGIN__
  ) {
    history.push('/login')
  }

  // else {
  //   // use session storage for desktop browsers
  //   if (!sessionStorage.getItem('loggedIn')) {
  //     // history.push('/login')
  //   }
  // }

  return children
}

export default AuthWrapper
